  <template >
  <div>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  <div>
  <div class="formPosition">
    
    <v-data-table    :headers="headers"  :items="estudantes" :search="searchInDb"  sort-by="data_"   class="elevation-3" >
      <template v-slot:top>
        <v-toolbar flat color="white">

       <!--  <v-btn to="/painelclasses" > <v-icon large color="green darken-2">arrow_back</v-icon> </v-btn > -->

                 <v-divider class="mx-8" inset vertical></v-divider>
          <v-toolbar-title>Estudantes fora da Turma

            </v-toolbar-title>

          <v-divider class="mx-8" inset vertical></v-divider>

          <!--  search  -->
<div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

          <div class="flex-grow-1"></div>
          <v-btn  v-if="searchInDb"  @click="initialize(searchInDb)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>
          <v-text-field
            v-model="searchInDb"
            append-icon="search"
            label="Pesquisa"

            single-line
            hide-details
          ></v-text-field>
          <!-- end  search  -->

          <!-- ============================================================================ -->
           <v-row justify="center">
            <v-dialog v-model="dialog_delete" persistent max-width="490">
              <v-card>
                <v-card-title class="headline">Eliminar estudante</v-card-title>
                <v-card-text>Tem a certeza que pretente continuar com operação ? </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialog_delete = false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="Delete()">Continuar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
      <!--=================================================================================-->

          <v-dialog v-model="dialog" max-width="800px">

            <v-card>

              <template >

                  <v-toolbar color="grey lighten-2">

             <v-row>
                    <v-col  cols="12" md="4">

<v-btn text    @click="close"><v-icon large color="primary" >clear</v-icon></v-btn>

    </v-col>

     <v-col cols="12" md="7">  <!--  form titlte section   {{ formTitle }}-->
     Enquadrar estudante na turma - AnoLectivo :   {{anolectivo}}
          <v-progress-circular
                v-if="progresso"
                indeterminate
                color="green"
        ></v-progress-circular>
 <div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

     </v-col>

      <v-col  cols="12" md="1">
     <v-btn   :disabled="!valid"           color="primary" text  @click="save"><v-icon large color="primary" >send</v-icon></v-btn>
   </v-col>

  </v-row>

                  </v-toolbar>

              </template>

 <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >

              <v-card-text>

                <v-container  >

<div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

                  <v-row>
                    <v-col  cols="12" md="5">
                      <v-text-field
                        :rules="ruleTextRequired"
                        v-model="editedItem.nome"
                        label="Nome"
                        :disabled="true"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        required
                        v-model="editedItem.bi"
                        :label="descricao"
                        v-mask="mascara"
                        :disabled="true"
                      ></v-text-field>

                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        required
                         v-model="editedItem.classe"
                        label="Classe"
                         :disabled="true"
                      ></v-text-field>

                    </v-col>

                  </v-row>

                   <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        required
                         v-model="editedItem.descricao"
                        label="Curso"
                        :disabled="true"
                       ></v-text-field>
                    </v-col>

                    <v-col md="4">
                       <v-select
                            :items="anoslectivos"
                            v-model="anolectivoSelected"
                            item-value="descricao"
                            item-text="novadescricao"
                            @change="FiltraAnolectivo()"
                            label="Selecione o Ano lectivo"
                            return-object
                          ></v-select>
                    </v-col>

            <v-col cols="12" md="4">

                      <v-combobox  id="turma"

                          v-model="editedItem.turma"
                          :rules="ruleRequired"
                          :value="undefined"
                          item-value="idTurma"
                          item-text="turmadescricao"
                          @change="SelecionaTurma()"
                          :items="turmasFiltered"
                          chips
                          label="Turma"
                        ></v-combobox>
                       </v-col>

 </v-row>

                </v-container>
              </v-card-text>

</v-form>

            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.eliminar="{ item }">
        <v-icon small color="red" class="mr-2" @click="ShowEliminar(item)">delete</v-icon>
       </template>
      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
       </template>
      <template v-slot:no-data>
     <!--   <v-btn color="primary" @click="initialize">Reset</v-btn>  -->

     Clica em + para adicionar novo estudante
      </template>
    </v-data-table>

  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import Swal from 'sweetalert2'
const ls = require('local-storage')

// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    datebi: null,
    date: null,
    descricao: 'Nº do Bi',
    valid: true,
    menu: false,
    menubi: false,
    habilitaBi: false,
    dialog_delete: false,
    startDate: null,
    cursos: [],
    anolectivoSelected: ls.get('anolectivo'),
    isLoading: false,
    turmasAll: [],
    idTurma: 0,
    progresso: false,
    idanolectivo: 0,
    mascara: '#########-AA-###',
    turmasFiltered: [],
    anoslectivos: [],
    municipiosAll: [],
    objEstudante: null,
    cor: '',
    municipiosFiltered: [],
    provincias: [],
    anolectivo: ls.get('anolectivo'),

    searchInDb: '',
    estudantes: [],
    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Nome',
        align: 'left',
        sortable: false,
        value: 'nome'
      },

      { text: 'Bilhete de Identidade / Outro documento', value: 'bi' },
      { text: 'Matricula', value: 'idMatricula' },
      { text: 'Curso  Inscrito', value: 'descricao' },
      { text: 'Classe Inscrito', value: 'classe' },
      { text: 'Anolectivo cadastrado', value: 'anoLectivo' },
      // { text: 'Data de Cadastro/Moficação', value: 'data_' },
      { text: 'Eliminar', value: 'eliminar', sortable: false },
      { text: 'Actions', value: 'action', sortable: false }
    ],

    msg: '',
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    editedItem: {

      pkPessoa: 0,
      bi: null,
      idPessoa: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      idCurso: 0,
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      idMatricula: 0,
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: null,
      descricao: '',
      ResidenteEm: 1,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null,
      trasferidoIN: 0
    },
    defaultItem: {
      pkPessoa: 0,
      idPessoa: '',
      bi: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      trasferidoIN: 0,
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: '',
      ResidenteEm: '',
      instituicao: '',
      instituicaodescricao: '',
      curso: null,
      turma: null
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    idclasse () {
      return this.$store.state.idclasse
    },

    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select

    // this.CarregActividades()

    this.initialize()
    this.LoadAnoslectivos()
    this.ObterIdAnoLectivo()
  },

  methods: {
    async initialize (searchInDb) {
      if (!this.estudantes.length) {
        try {
          this.isLoading = true
          this.estudantes = await axios
            .get('/estudantesForaTurmaFindAll')
            .then(res => res.data)
          this.isLoading = false
        } catch (error) {
          this.isLoading = false

          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
      //   let  payload =""
    }, // combo qua depende de outra combo
    // METHODO FOR VALIDATION
    validate () {
      this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    // END METHOD FOR VAL
    outroDoc () {
      if (this.descricao === 'Outro Doc.') {
        this.descricao = 'Nº do Bi'
      } else {
        this.descricao = 'Outro Doc.'
      }
    },

    loadTurmaComb (curso) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === curso.idCurso)
      this.$nextTick(() => { this.editedItem.turma = undefined })
    },
    loadMunicipioComb (provincia) {
      this.$nextTick(() => { this.municSelectedForComb = undefined })
      // eslint-disable-next-line no-return-assign
      return this.municipiosFiltered = this.municipiosAll.filter(municipio => municipio.idProvincia === provincia.idProvincia)
    },
    async initializeMunicipiosAll () {
      try {
        this.isLoading = true
        this.municipiosAll = await axios
          .get('/municipioFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    SelecionaTurma () {
    },


    async FiltraAnolectivo (){
       this.turmasFiltered = []
       this.turmasAll = await  this.initializeturmasAll(this.objEstudante.trasferidoIN).then((res)=>res.data)
       this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === this.editedItem.idCurso)
    },

    async initializeProvincias () {
      try {
        this.isLoading = true
        this.provincias = await axios
          .get('/provinciaFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
      } catch (error) {

      }
    },

    ShowEliminar (item) {
      this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item)

      this.dialog_delete = true
    },

    async Delete () {
      let params =
        {
          pkLixeira: 0,
          tabela_from: 'Pessoa',
          descricao: 'Eliminou o registro do estudante :' + this.editedItem.nome + ' Bilhete: ' + this.editedItem.bi + ' da lista de estudantes fora da turma',
          id_from: this.editedItem.pkPessoa,
          matricula: this.editedItem.idMatricula,
          status: 1
        }

      try {
        let msg = await axios
          .post('/LixeiraInsertOrUpdate', params)
          .then(res => res.data)
        if (!msg.length) {
          if (msg.affectedRows > 0) {
            this.text = 'Estudante eliminado com sucesso'
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 5000 })
            this.dialog_delete = false
            this.estudantes.splice(this.editedIndex, 1)
          }
        }
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeturmasAll (anoacademico) {
     //  turmaFindWithEstudanteCount
      try {
         return  await axios
          .get('/turmaFindAll/' + anoacademico+'/'+this.anolectivoSelected.descricao)
       } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async LoadAnoslectivos () {
      try {
        this.isLoading = true
        this.anoslectivos = await axios
          .get('/listarAnoLectivoAll')
          .then(res => res.data)
          this.anolectivoSelected = this.anoslectivos[0]
         this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } finally {
        this.isLoading = false
      }
    },
    async editItem (item) {
      this.turmasAll = await  this.initializeturmasAll(item.trasferidoIN).then((res)=>res.data)
      this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.objEstudante = item
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === this.editedItem.idCurso)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.estudantes.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.delete(item.pkInscricao_na_turma)
      // this.estudantes.splice(index, 1)*/
    },

    close () {
      this.dialog = false
      this.$refs.form.reset()
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async save () {
      this.progresso = true
      if (this.$refs.form.validate()) {
        const ls = require('local-storage')

        let params =
        {
          idmatricula: this.editedItem.idMatricula,
          idturma: this.editedItem.turma.idTurma,
          pkPessoa: this.editedItem.pkPessoa,
          idanolectivo: this.idanolectivo,
          pkTurma: this.editedItem.turma.pkTurma,
          idcurso: this.editedItem.turma.idCurso,
          bi: this.editedItem.bi,
          idanoacademico: this.editedItem.turma.idAno_Academico,
          resultado: 0,
          descricao_resultado: 'Não Transita',
          fromtransferencia: 0,
          fromMudancaclasse: 0,
          anolectivo: this.anolectivoSelected.descricao,
          ultimoAnoFeito: this.objEstudante.anoLectivo
        }

        try {
          // this.isLoading = true
          let result = await axios
            .post('/confirmacaoInsertOrUpdate', params)
            .then(res => res.data)
           this.progresso = false
           if(result.affectedRows >= 1){
             Swal.fire('Informação','Estudante colocado na turma com sucesso','success')
             this.dialog = false
            this.initialize()
           }else{
             Swal.fire('Informação','Ocorreu um erro ao tentar efectuar a operação','error')
           }
          
        } catch (error) {
          this.progresso = false

          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
      this.progresso = false
    },

    Limpar (msg) {
      if (msg === 'CONFIRMAÇÃO EFECTUADA COM SUCESSO') {
        this.$store.dispatch('textMessage', { 'msg': msg, 'classMessage': 'msgSucess', 'timeout': 6000 })
        this.dialog = false
      }
    },

    async ObterIdAnoLectivo () {
      try {
        let msg = await axios
          .get('/ObterIdAnoLectivo/' + ls.get('anolectivo'))
          .then(res => res.data)
        this.idanolectivo = msg[0].idAnoLectivo
      } catch (error) {
        this.text = error.message
      }
    },

    async delete (idv) {
      try {
        var msg = await axios
          .get('/estudanteDeleteById/' + idv)
          .then(res => res.data)
        this.text = 'Deleted ' + msg.message

        this.initialize()

        this.close()
      } catch (error) {
        this.text = error.message
      } finally {

      }
    }
  }
}
</script>
<style scoped>

.bg {
 color:green;
 background: red
}

</style>
